import { render } from "./carouselHomeHandy.vue?vue&type=template&id=09959397"
import script from "./carouselHomeHandy.vue?vue&type=script&lang=js"
export * from "./carouselHomeHandy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__